<script setup>
import LoadingDummySelect from '@/assets/js/src/components/loading/LoadingDummySelect'
import { useMessagesLoaded, } from '@/assets/js/src/modules/lang/_composables/useMessagesLoaded'
import { useTranslation, } from '@/assets/js/src/util/composables/useTranslation'
import { toRefs, } from 'vue'

const abbreviations = defineModel({
    type: Array,
    default: () => ([]),
})

const props = defineProps({
    items: {
        type: Object,
        default: () => ({}),
    },
    labelKey: {
        type: String,
        default: '',
    },
})

const { labelKey, } = toRefs(props)
const { messagesLoaded, } = useMessagesLoaded([ labelKey.value.split('.')[1] ?? 'resource', ])
const { t, } = useTranslation()
</script>

<template>
    <div class="mb-7">
        <v-select
            v-if="messagesLoaded"
            v-model="abbreviations"
            :items="items"
            :label="t(labelKey)"
            variant="underlined"
            multiple
            hide-details
        >
            <template #chip="{ item }">
                <v-chip
                    class="trans"
                    label
                >
                    {{ item.title }}
                </v-chip>
            </template>
        </v-select>
        <loading-dummy-select
            v-else
        ></loading-dummy-select>
    </div>
</template>

<style>
.bs-app .v-field__input {
    --v-input-control-height: 58px;
}
</style>
